import { FC, ChangeEvent } from 'react'
import { TextField } from '@mui/material'
import { StyledAutocomplete } from './integrationsSearch.styles'
import { InputSearchIcon } from 'ui/components/svg'
import theme from 'theme'

interface Props {
  onInputChange: any
  placeholder?: string
  searchValue: string
  resetKey?: string
  setSearchValue: any
}

const IntegrationsSearch: FC<Props> = ({
  onInputChange,
  searchValue,
  resetKey,
  setSearchValue,
  placeholder = '',
  ...rest
}) => (
  <StyledAutocomplete
    key={resetKey}
    freeSolo
    disableClearable
    id="integrations-search-box"
    options={[]}
    {...rest}
    onInputChange={onInputChange}
    renderInput={(params) => (
      <TextField
        {...params}
        value={searchValue}
        onChange={(e) => {
          if (params?.inputProps?.onChange) {
            params.inputProps.onChange(e as ChangeEvent<HTMLInputElement>)
          }
          setSearchValue(e.target.value)
        }}
        placeholder={placeholder}
        InputProps={{
          ...params.InputProps,
          startAdornment: <InputSearchIcon />
        }}
        sx={{
          '.MuiOutlinedInput-input': {
            color: searchValue.length > 0 ? theme.colors.neutral : `${theme.colors.dustyRoseGray} !important`,
            WebkitTextFillColor:
              searchValue.length > 0 ? theme.colors.neutral : `${theme.colors.dustyRoseGray} !important`
          },
          "html[data-theme='light'] & .MuiOutlinedInput-input": {
            color: `${theme.colors.menuItemText} !important`,
            WebkitTextFillColor: `${theme.colors.menuItemText} !important`
          }
        }}
      />
    )}
  />
)

export default IntegrationsSearch
